'use strict';

import React from 'react';

import { connect } from 'react-redux';

import Logger from '../../../utils/Logger';
import classnames from 'classnames';
import OTButton from '../../tag/OTButton';
import BaseQuestionnaireListItem from '../BaseQuestionnaireListItem';
import { showGtiBeginModal } from '../../../data/service/gti/actions';
import { QUESTIONNAIRES, SERVICES } from '../../../data/reducer';
import { FormattedMessage } from 'react-intl';
import OTIcon from '../../tag/OTIcon';
import MobileClientModal from '../MobileClientModal';

const { id: module_id } = module;
const logger = Logger(module_id);

class QuestionnaireListItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showMobileClientModal: false,
    };
  }

  toggleModalState = () => {
    this.setState({
      showMobileClientModal: !this.state.showMobileClientModal,
    });
  };

  render() {
    let { showGtiBeginModal, gtiStatus, mobileClientState } = this.props;

    return (
      <>
        <BaseQuestionnaireListItem
          left={
            <>
              <span className={'ot-queryitem__name'}>
                <FormattedMessage id={'gti.questionnaireitem.title'} />
              </span>
              <>
                <br />
                <span className={'ot-queryitem__description'}>
                  <OTIcon
                    config={{
                      type: 'custom',
                      name: 'palaute',
                      color: 'darkblue',
                    }}
                    style={{
                      height: '13px',
                      width: '15px',
                      marginRight: '5px',
                    }}
                  />
                  <FormattedMessage id={'gti.link.message'} />
                </span>
              </>
            </>
          }
          leftWidth={'span8'}
          right={
            <>
              {!mobileClientState ? (
                <OTButton
                  color={'light'}
                  className={classnames(
                    'pull-right',
                    'ot-queryitem__button',
                    gtiStatus !== 'ACTIVE' && 'ot-queryitem__button--disabled'
                  )}
                  disabled={gtiStatus === 'INACTIVE'}
                  onClick={showGtiBeginModal}
                  message={'navigate.to.answer'}
                />
              ) : (
                <OTButton
                  color={'light'}
                  className={classnames('pull-right', 'ot-queryitem__button')}
                  onClick={() => this.toggleModalState()}
                  message={'navigate.to.answer'}
                />
              )}
            </>
          }
          rightWidth={'span4'}
        />
        {this.state.showMobileClientModal && (
          <MobileClientModal
            isOpen={this.state.showMobileClientModal}
            hideModal={() => this.toggleModalState()}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    gtiStatus: state[SERVICES].gti.gtiStatus,
    mobileClientState: state[QUESTIONNAIRES].mobileClientState,
  };
};

export default connect(mapStateToProps, { showGtiBeginModal })(
  QuestionnaireListItem
);
